import { Controller, useFormContext } from "react-hook-form";
import {
  Input,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../ui";
import { FormLabel } from "../FormLabel";
import { FormErrorLabel } from "../FormErrorLabel";
import { BadgeInfo } from "lucide-react";
import { useRef } from "react";

const FormInput = ({
  name,
  label,
  // control,
  error,
  isRequired,
  onChange,
  noSpace,
  info,
  ...rest
}: any) => {
  const lastKeyRef = useRef<string | null>(null);
  const { control } = useFormContext();

  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label}{" "}
          {rest?.disabled ? (
            <> </>
          ) : (
            <span className="text-red-700">{isRequired ? "*" : ""}</span>
          )}
          {info && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger className="mx-1" type="button">
                  <BadgeInfo className="h-3 w-3 stroke-yellow-600" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>{info}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            {...rest}
            onKeyDown={(e) => {
              lastKeyRef.current = e.key;
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (onChange) onChange(e);
              const value = e.target.value;
              const lastKey = lastKeyRef.current;

              if (value === "") {
                field.onChange(e);
                return;
              }

              if (noSpace && value.includes(" ")) {
                return;
              }

              if (rest.format) {
                if (lastKey === "Backspace" || lastKey === "Delete") {
                  field.onChange(value); // raw value
                  return;
                }

                field.onChange(rest.format(value)); // formatted
                return;
              }

              if (rest.variant === "char" && !/^[A-Za-z]+$/.test(value)) return;

              if (rest.variant === "integer" && !/^\d+$/.test(value)) return;

              if (rest.variant === "float" && !/^\d*\.?\d*$/.test(value))
                return;

              if (rest.maxLength && value.length > rest.maxLength) return;

              field.onChange(e);
            }}
          />
        )}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormInput;
